import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container as RBContainer } from 'rebass';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import { compose, branch, renderComponent } from 'recompose';
import styled from 'styled-components';

import AddPersonalInformation from '../../Containers/AddPersonalInformation';
import ContentWrapper from '../../Components/ContentWrapper';
import { query } from '../../GraphQL/query/MyProfile.query';
import { updatePersonalInformation } from '../../Redux/user-profile/actions';
import { isLoading, isFirstTimeLogin } from '../../Redux/user-profile/selectors';

const LContainer = styled(RBContainer)`
  min-width: 320px;
  max-width: 440px;
`;
class RegisterProfile extends Component {
  handleUpdatedUserProfile = () => {
    this.props.updatePersonalInformation();
  };
  componentDidMount = () => {
    this.props.client.query({ query });
  };

  render() {
    const { isLoading } = this.props;
    return (
      <ContentWrapper>
        <LContainer>
          <AddPersonalInformation
            loading={isLoading}
            onClickUpdatedUserProfile={this.handleUpdatedUserProfile}
          />
        </LContainer>
      </ContentWrapper>
    );
  }
}

export default compose(
  connect(
    state => ({ isFirstTimeLogin: isFirstTimeLogin(state), isLoading: isLoading(state) }),
    {
      updatePersonalInformation,
    },
  ),
  branch(
    props => !props.isFirstTimeLogin,
    renderComponent(props => {
      const { from } = props.location.state || { from: { pathname: '/' } };
      return <Redirect to={from} />;
    }),
  ),
  withApollo,
)(RegisterProfile);
